import { NgModule, Component, OnInit, OnDestroy } from '@angular/core';
import { Field, FieldWrapper, FieldType } from 'ng-formly';
import { EntityApi } from '../../sdk/services/custom';
import { Router, ActivatedRoute } from '@angular/router';
import { LoopBackFilter, Entityrecord } from '../../sdk/models/';
import * as _ from "lodash";

/*
This custom field is used to select entities for an app.
*/

@Component({
  selector: 'formly-entity-selector',
  template: `
   <ng-select *ngIf="items.length > 0"   
              [active]="selectedvalues"
              (data)="refreshValue($event)"
              (selected)="selected($event)"
              (removed)="removed($event)"
              [items]="items"
              [multiple]="to.multiple"
               [disabled]="to.disabled"
              placeholder="" >
  </ng-select>
  `, styleUrls: ['./ng2select.scss'],
  providers: [EntityApi]
})
export class EntitySelectMultiple extends FieldType implements OnInit, OnDestroy {
  public _loopbackfilter: LoopBackFilter = <LoopBackFilter>{};
  public items: any = [];
  public selectedvalues: any;
  constructor(public _EntityApi: EntityApi) {
    super();

  }

  ngOnInit() {
     if (this.to["multiple"]) {
      this.to["multiple"] = true;
      this.selectedvalues = [];
    } else {
      this.to["multiple"] = false;
      this.selectedvalues = "";
    }
    //1) Load the drop down values    
    this._loopbackfilter.where = { 'appId': this.model.appId };
    //Hack - Get the app id from the model itself.
    //Get the entities for the App
    this._EntityApi.find(this._loopbackfilter).subscribe((entities) => {
      if (entities) {
        
        for (var i = 0; i < entities.length; i++) {
          if (this.model.id !== entities[i]["id"]) {
            this.items.push({ id: entities[i]["id"], text: entities[i]["label"] })
          }

          if (this.model[this.key] && this.model[this.key].indexOf(entities[i]["id"]) > -1) {
            if (this.to["multiple"]) {
              this.selectedvalues.push({ id: entities[i]["id"], text: entities[i]["label"] });
            } else {
              this.selectedvalues = { id: entities[i]["id"], text: entities[i]["label"] };
            }
          }
        }
        //Sort the values
         this.items = _.sortBy(this.items, 'text');
      }
    });

  }

  ngOnDestroy() {
    if (this.to["multiple"]) {
      this.selectedvalues = [];
    } else {
      this.selectedvalues = "";
    }
  }

  private value: any = {};


  public selected(value: any): void {
    /*
    Push the selected value to the model
    */
    if (this.model[this.key] && this.model[this.key].length) {
      this.model[this.key].push(value.id);
    } else {
      this.model[this.key] = [value.id];
    }

  }

  public removed(value: any): void {

    /*
   Remove the removed value to the model
   */
    if (this.model[this.key] && this.model[this.key].length) {
      this.model[this.key].splice(this.model[this.key].indexOf(value.id), 1);
    }
  }

  public typed(value: any): void {
    
  }

  public refreshValue(value: any): void {
    this.value = value;
  }

}





// WEBPACK FOOTER //
// ./src/app/shared/components/fields/selectentity-multiple.ts